<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col class="table-size">
        <b-card
            title="جزئیات پرواز"
        >
          <b-form
              ref="flightform"
              @submit.prevent
          >

            <b-row>

              <b-col
                  class="mt-2"
                  md="10"
                  offset-md="1"
              >
                <b-tabs>
                  <b-tab
                      active
                  >
                    <template #title>
                      <feather-icon
                          icon="InfoIcon"
                          size="16"
                          class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline">اطلاعات کلی</span>
                    </template>

                    <b-row class="mt-3">


                      <b-col md="4">
                        <b-form-group
                            label="مبدا"
                            label-for="OriginId"
                        >
                          <z-airport
                              v-model="Form.OriginId"
                              :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="مقصد"
                            label-for="DestinationId"
                        >
                          <z-airport
                              v-model="Form.DestinationId"
                              :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="ایرلاین"
                            label-for="AirlineId"
                        >
                          <z-airline
                              v-model="Form.AirlineId"
                              :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="هواپیما"
                            label-for="AirplaneId"
                        >
                          <z-airplane
                              v-model="Form.AirplaneId"
                              :clearable="false"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="شماره پرواز"
                            label-for="Number"
                        >
                          <b-form-input
                              v-model="Form.Number"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="وضعیت"
                            label-for="Status"
                        >
                          <v-select
                              v-model="Form.Status"
                              :reduce="x => x.value"
                              label="text"
                              :clearable="false"
                              :options="enums('FlightStatus')"
                          />
                        </b-form-group>
                      </b-col>

                      <template v-if="$route.params.id">
                        <b-col md="4">
                          <b-form-group
                              label="تاریخ"
                              label-for="Date"
                          >
                            <date-picker
                                v-model="Form.Date"
                                placeholder=""
                                :disabled="true"
                            />
                          </b-form-group>
                        </b-col>
                      </template>
                      <template v-else>
                      <b-col md="4">
                        <b-form-group
                            label="از تاریخ"
                            label-for="FromDate"
                        >
                          <date-picker
                              v-model="Form.FromDate"
                              placeholder=""
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="تا تاریخ"
                            label-for="FromDate"
                        >
                          <date-picker
                              v-model="Form.ToDate"
                              placeholder=""
                          />
                        </b-form-group>
                      </b-col>
                      </template>

                      <b-col md="4">
                        <b-form-group
                            label="زمان حرکت پرواز"
                            label-for="DepartureTime"
                        >
                          <date-picker
                              type="time"
                              v-model="Form.DepartureTime"
                              format="YYYY-MM-DD HH:mm"
                              display-format="HH:mm"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                            label="مدت زمان پرواز"
                            label-for="Duration"
                        >
                          <date-picker
                              type="time"
                              v-model="Form.Duration"
                              format="YYYY-MM-DD HH:mm"
                              display-format="HH:mm"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                            label="توضیحات"
                            label-for="Description"
                        >
                          <b-form-textarea
                              id="Description"
                              v-model="Form.Description"
                              name="Description"
                              rows="3"
                          />
                        </b-form-group>

                      </b-col>


                    </b-row>


                  </b-tab>

                  <b-tab>

                    <template #title>
                      <feather-icon
                          icon="SlidersIcon"
                          size="16"
                          class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline">کلاس</span>
                    </template>

                    <b-row class="mt-3">
                      <b-col

                        md="12"
                    >
                   
                        <b-row>
                          <template v-for="(item, index) in Form.FlightClass">
                            <b-col md="4">
                              <b-form-group
                                  label="عنوان"
                                  label-for="Title"
                              >
                                <b-form-input
                                    v-model="item.Title"
                                    autocomplete="off"
                                />
                              </b-form-group>
                            </b-col>

                            <b-col md="4">
                              <b-form-group
                                  label="ظرفیت"
                                  label-for="Capacity"
                              >
                                <b-input-group append="نفر">
                                  <cleave
                                      v-model="item.Capacity"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col md="4">
                              <b-form-group
                                  label="بار مجاز"
                                  label-for="FreeBaggage"
                              >
                                <b-input-group append="کیلوگرم">
                                  <cleave
                                      v-model="item.FreeBaggage"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                            <b-col md="4">
                              <b-form-group
                                  label="قیمت بزرگسال"
                                  label-for="AdultFare"
                              >
                                <b-input-group append="تومان">
                                  <cleave
                                      v-model="item.AdultFare"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col md="4">
                              <b-form-group
                                  label="قیمت کودک"
                                  label-for="ChildFare"
                              >
                                <b-input-group append="تومان">
                                  <cleave
                                      v-model="item.ChildFare"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col md="4">
                              <b-form-group
                                  label="قیمت نوزاد"
                                  label-for="InfantFare"
                              >
                                <b-input-group append="تومان">
                                  <cleave
                                      v-model="item.InfantFare"
                                      class="form-control"
                                      :raw="false"
                                      :options="options"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col class="mt-25 mb-50"  cols="12">
                              <hr>
                            </b-col>

                          </template>

                          <b-col class="mb-1">
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="gradient-info"
                                @click="addFlightClass"
                            >
                              <feather-icon
                                  icon="PlusIcon"
                                  class="mr-25"
                              />
                              <span>افزودن</span>
                            </b-button>
                          </b-col>
                        </b-row>



                      </b-col>
                    </b-row>


                  </b-tab>

                </b-tabs>


<b-row>
  <b-col cols="12">
    <hr>
  </b-col>
  <b-col class="mt-1 mb-2 text-center">
    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1"
        @click="save"
    >
      ذخیره
    </b-button>
    <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="outline-secondary"
        @click="back"
    >
      بازگشت
    </b-button>
  </b-col>

</b-row>
              </b-col>


            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZCity from "@/tools/city.vue";
import ZAirline from "@/tools/airline.vue";
import ZAirport from "@/tools/airport.vue";
import ZAirplane from "@/tools/airplane.vue";

export default {
  name: 'FlightDetails',
  components: {ZAirplane, ZAirport, ZAirline, ZCity},
  data() {
    return {
      Form: {
        Id: null,
        OriginId: null,
        DestinationId: null,
        Status: 0,
        FromDate: null,
        ToDate: null,
        AirlineId: null,
        AirplaneId: null,
        Number: null,
        IsForeign: false,
        Description: null,
        FlightClass: [],
        Date: null
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
        // onValueChanged: this.changeCalorie,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }else {
      this.addFlightClass()
    }
  },
  methods: {
    save() {
      let url = this.$api.flight.add
      if (this.$route.params.id) {
        url = this.$api.flight.update
      }

      this.loading = true

      const form = JSON.parse(JSON.stringify(this.Form))

      if (form.DepartureTime){
        form.DepartureTime = form.DepartureTime.split(' ')[1]
      }

      if (form.Duration){
        form.Duration = form.Duration.split(' ')[1]
      }



      form.FlightClass.forEach((item, index) => {
        item.Capacity = item.Capacity?.replaceAll(',', '')
        item.FreeBaggage = item.FreeBaggage?.replaceAll(',', '')
        item.AdultFare = item.AdultFare?.replaceAll(',', '')
        item.ChildFare = item.ChildFare?.replaceAll(',', '')
        item.InfantFare = item.InfantFare?.replaceAll(',', '')
      })

      this.$http.post(
          url, form,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.flight.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data

            this.Form.Duration = '2024/01/01 ' + this.Form.Duration
            this.Form.DepartureTime = '2024/01/01 ' + this.Form.DepartureTime

          })
    },
    addFlightClass() {
      this.Form.FlightClass.push({
        Title: null,
        Capacity: null,
        FreeBaggage: null,
        AdultFare: null,
        ChildFare: null,
        InfantFare: null,
      })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>